// extracted by mini-css-extract-plugin
export default {"title":"WizardTitle_title__jtCP4","step":"WizardTitle_step__Mvocu","description":"WizardTitle_description__nd++x"};